import * as Sentry from '@sentry/nextjs';

const SENTRY_DSN_SERVER = process.env.NEXT_PUBLIC_SENTRY_DSN;
const APP_ENV = process.env.NEXT_PUBLIC_APP_ENV;

if (SENTRY_DSN_SERVER) {
  Sentry.init({
    dsn: SENTRY_DSN_SERVER,
    tracesSampleRate: 1.0,
    environment: APP_ENV
  });
} else {
  // eslint-disable-next-line no-console
  console.info('Sentry DNS server is not set - skipping initialization');
}
